/**
 * Raw design-system color palette.
 *
 * This is a private implementation detail — only config.ts and customTokens.ts
 * should import from here. Consumers of the design system use semantic tokens
 * (antd token aliases or DesignSystemTokens), never the palette directly.
 */
export const palette = {
  // Primary blue ramp
  colorPrimary: '#507ee6',
  colorPrimaryBorderHover: '#69b1ff',
  colorPrimaryFocusBorder: '#bae0ff',
  colorPrimaryBg: '#f3f9ff',
  colorPrimaryBgHover: '#d6eaff',
  colorPrimaryBgActive: '#c0dcff',

  // Error red
  colorError: '#cf1322',
  colorErrorAlpha10: 'rgba(207, 19, 34, 0.1)',
  colorErrorSurface: '#fae7e8',
  colorErrorBorder: '#eba0a6',

  // Warning
  colorWarning: '#faad14',
  colorWarningAlpha10: 'rgba(250, 173, 20, 0.1)',
  colorWarningSurface: '#fef3e7',
  colorWarningBorder: '#fcc58a',

  // Success
  colorSuccessSurface: '#eef8f3',
  colorSuccessBorder: '#a8dcc3',

  // Text
  colorText: 'rgba(0, 0, 0, 0.88)',
  colorTextSecondary: '#595959',
  colorTextDisabled: '#8c8c8c',
  colorTextPlaceholder: '#bfbfbf',

  // Border / surface
  colorBorder: '#e8e8e8',
  colorBorderHover: '#bfbfbf',

  // Neutral interactive (tertiary)
  colorNeutralBg: '#f5f5f5',
  colorNeutralBgHover: '#ebebeb',
  colorNeutralBgActive: '#e0e0e0',
  colorNeutralBorderHover: '#d9d9d9',

  // Select
  colorSelectTagBorderHover: '#bfbfbf'
} as const
